import React, { useEffect, useState } from "react";
import { request } from "../../../utils/request";
import { formatCurrency } from "../../../utils/helpers";
import Loader from "../../general/Loader";

const TarjetaCxC = ({anio, mes, vendedor, styles}) => {
    const tarjeta = "cxc";
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(true)
    const [expandir, setExpandir] = useState(false);

    const getData = async (anio,mes) => {
        setLoading(true);
        setExpandir(false);

        const req = await request(`dashboard/gi?tarjeta=${tarjeta}&mes=${mes}&anio=${anio}&vendedor=${vendedor ? 1 : 0}`);

        if (req.success) {
            setData(req.data);
            setLoading(false);
        }
    };

    useEffect(() => {
      getData(anio,mes);
    }, [anio, mes]);

    if (loading === true) {
        return <div style={styles.columnStyles}>
            <Loader />
        </div>;
    }

    return (
        <div style={styles.columnStyles}>
            <div style={styles.columnContainer}>
                <div style={styles.header}>
                    <div className="color-primary" style={styles.principal}>
                        {formatCurrency(data.total)}
                    </div>
                    <div style={styles.subtitulo}>
                    Cuentas por Cobrar
                    </div>
                </div>

                <div style={{
                    ...styles.infoBlockContainer,
                    maxHeight: expandir ? '250px' : '80px'
                }} className="row">
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countVigentes}</small> {formatCurrency(data.totalVigentes)}</strong>
                        </div>
                        <small style={styles.label}>Vigentes</small>
                    </div>
                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countVencidas}</small> {formatCurrency(data.totalVencidas)}</strong>
                        </div>
                        <small style={styles.label}>Vencidas</small>
                    </div>

                    <div style={styles.infoBlock}>
                        <div>
                            <strong><small className="badge badge-success">{data?.countIncobrables ?? 0}</small> <span style={{color: "#f00"}}>{formatCurrency(data.totalIncobrables)}</span></strong>
                        </div>
                        <small style={{...styles.label }}>Incobrables</small>
                    </div>
                </div>

                {!expandir && (
                    <button type="button" style={styles.expandir} onClick={() => setExpandir(true)}>Expandir</button>
                )}
            </div>
        </div>
    )
}

export default TarjetaCxC;
